import moment from 'moment'

export const getTimeAgo = (date: string | null): string => {
    if (!date) return 'N/A'

    const now = moment()

    const diffInDays = now.diff(moment(date), 'days')
    const diffInHours = now.diff(moment(date), 'hours')
    const diffInMinutes = now.diff(moment(date), 'minutes')

    if (diffInDays >= 1) return `${diffInDays} days ago`
    if (diffInHours >= 1) return `${diffInHours} hours ago`

    return `${diffInMinutes} mins ago`
}
